import React from 'react';
import SettingsCardSC, { CardTopSC } from './settings-card.styled';
import { HeadingFour, BodyText } from '../../typography';
import Button from '../../ui/button';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

const SettingsCard = ({ onEditClick, headline, subText, children }) => {
  return (
    <SettingsCardSC>
      <CardTopSC>
        <HeadingFour>
          <FormattedHTMLMessage id={headline} defaultMessage={dlt[`${headline}`]} />
        </HeadingFour>
        <Button type="LINK" onClick={onEditClick}>
          <FormattedMessage id="global_edit" defaultMessage={dlt['global_edit']} />
        </Button>
        <div className="sub-text-wrap">
          <BodyText className="black-transparent">
            <FormattedHTMLMessage id={subText} defaultMessage={dlt[`${subText}`]} />
          </BodyText>
        </div>
      </CardTopSC>

      {children}
    </SettingsCardSC>
  );
};

export default SettingsCard;
